import { defineCapability } from './internal';
import { args } from '../common/args';
export const CHANGE_SEARCH_CAP = defineCapability({
  name: 'CHANGE_SEARCH_CAP',
  args: {
    query: args.optional(args.string()),
    filters: args.optional(args.arrayOf(args.string()))
  }
});